import React, { Component } from 'react';
import * as AdultAuthValidType from "../../constants/AdultAuthValidType";

export default class AgeAuthAlertModal extends Component {
  constructor(props) {
    super(props);
    this.gotoAgeAuth = this.gotoAgeAuth.bind(this);
    this.handleCloseWindow = this.handleCloseWindow.bind(this);
    this.gotoLogin = this.gotoLogin.bind(this);
    this.gotoLogout = this.gotoLogout.bind(this);
  }

  gotoAgeAuth() {
    const { profile } = this.props;
    const ageAuthUrl = profile.authInfo.get('ageAuthUrl');
    location.href = ageAuthUrl;
  }

  handleCloseWindow() {
    const { profile } = this.props;
    if (window.opener) {
      if (window.__BROWSER_NAME__ === "Mobile Safari") {
        const open = window.open(',', '_self');
        if (open) {
          open.close();
        } else {
          window.close();
        }
      } else {
        window.close();
      }
    } else {
      location.href = "/" + profile.get('profileId');
    }
  }

  gotoLogin() {
    const { profile } = this.props;
    const returnUrl = profile.permalink;
    location.href = `${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/login?continue=${returnUrl}`;
  }

  gotoLogout() {
    const { profile } = this.props;
    const returnUrl = profile.permalink;
    const loginPage = `${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/login?continue=${returnUrl}`;
    location.href = `${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${loginPage}`;
  }

  render () {
    const { profile, validType, renderCancelBtn } = this.props;
    const profileName = profile.get('name');
    const cancelBtnStyle = renderCancelBtn ? 'block' : 'none';

    if (!profile.get('isAdult') || validType == AdultAuthValidType.VERIFIED) {
      return ('');
    } else if (validType == undefined || validType == AdultAuthValidType.NOT_FOUND) {
      return (
          <div>
            <div className="dimmed_layer"></div>
            <div className="plus_layer adult_layer" style={{marginTop: '-120px'}}>
              <div className="layer_body">
                <strong className="tit_layer">
                  <img src="http://k.kakaocdn.net/dn/cIPppK/btqrEUNCeMl/ck0KHBxLilu60CEWbXTXEK/img_xl.jpg"
                       className="info_cate" width="33" height="19" alt="성인"
                  />
                  성인인증이 필요합니다.
                </strong>
                <p className="txt_layer">해당 채널 "{profileName}"(은)는 청소년에 유해한 정보/컨텐츠 등이 포함되어 있을 수 있어
                  정보통신망 이용촉진및 정보보호 등에 관한 법률 및 청소년 보호법에 따라 19세미만의 청소년이 이용할 수 없습니다.<br/>
                  로그인 후 카카오 계정의 본인 확인을 해주세요.</p>
                <div className="app_btn">
                  <button type="button"
                    className="btn_g"
                    onClick={this.gotoLogin}
                  >
                    <span className="inner_txt">로그인 하러 가기</span>
                  </button>
                </div>
                <button type="button" className="btn_close"
                  style={{ display: cancelBtnStyle }}
                  onClick={this.handleCloseWindow}
                ><span className="ico_plus ico_close">레이어 닫기</span></button>
              </div>
            </div>
          </div>
      );
    } else if ( validType == AdultAuthValidType.UNAUTHORIZED || validType == AdultAuthValidType.UNAUTHORIZED_AGE) {
      return (
          <div>
            <div className="dimmed_layer"></div>
            <div className="plus_layer adult_layer" style={{marginTop: '-120px'}}>
              <div className="layer_body">
                <strong className="tit_layer">
                  <img src="http://k.kakaocdn.net/dn/cIPppK/btqrEUNCeMl/ck0KHBxLilu60CEWbXTXEK/img_xl.jpg"
                       className="info_cate" width="33" height="19" alt="성인"
                  />
                  성인인증이 필요합니다.
                </strong>
                <p className="txt_layer">해당 채널 "{profileName}"(은)는 청소년에 유해한 정보/컨텐츠 등이 포함되어 있을 수 있어
                  정보통신망 이용촉진및 정보보호 등에 관한 법률 및 청소년 보호법에 따라 19세미만의 청소년이 이용할 수 없습니다.<br/>
                  카카오 계정의 본인 확인을 해주세요.</p>
                <div className="app_btn">
                  <button type="button" className="btn_g"
                          onClick={this.gotoAgeAuth}
                  >
                    <span className="inner_txt">본인인증 하러 가기</span>
                  </button>
                </div>
                <button type="button" className="btn_close"
                  style={{ display: cancelBtnStyle }}
                  onClick={this.handleCloseWindow}
                ><span className="ico_plus ico_close">레이어 닫기</span></button>
              </div>
            </div>
          </div>
      );
    } else if (validType == AdultAuthValidType.LOWER_AGE_LIMIT) {
      return (
          <div>
            <div className="dimmed_layer"></div>
            <div className="plus_layer adult_layer" style={{marginTop: '-120px'}}>
              <div className="layer_body">
                <strong className="tit_layer">
                  <img src="http://k.kakaocdn.net/dn/cIPppK/btqrEUNCeMl/ck0KHBxLilu60CEWbXTXEK/img_xl.jpg"
                       className="info_cate" width="33" height="19" alt="성인"
                  />
                  성인인증이 필요합니다.
                </strong>
                <p className="txt_layer">해당 채널 "{profileName}"(은)는 청소년에 유해한 정보/컨텐츠 등이 포함되어 있을 수 있어
                  정보통신망 이용촉진및 정보보호 등에 관한 법률 및 청소년 보호법에 따라 19세미만의 청소년이 이용할 수 없습니다.
                </p>
                <div className="app_btn">
                  <button type="button" className="btn_g"
                    onClick={this.gotoLogout}
                  >
                    <span className="inner_txt">다른 계정으로 로그인</span></button>
                </div>
                <button type="button" className="btn_close"
                  style={{ display: cancelBtnStyle }}
                  onClick={this.handleCloseWindow}
                ><span className="ico_plus ico_close">레이어 닫기</span></button>
              </div>
            </div>
          </div>
      );
    }

    return ('');
  }
}



// WEBPACK FOOTER //
// ./src/components/AgeAuthAlertModal/index.js